import React from 'react';

export const SearchIcon = ({ color = '#2555FE', ...restProps }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M15.8333 9.16667C15.8333 12.5724 13.0724 15.3333 9.66667 15.3333C6.26091 15.3333 3.5 12.5724 3.5 9.16667C3.5 5.76091 6.26091 3 9.66667 3C13.0724 3 15.8333 5.76091 15.8333 9.16667Z"
        fill="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1667 16.6667L14.25 13.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
